export type MobProductListItem = {
  SKU: string
  name: string
  _telus: {
    productName: string
    productBrand: string
    category: string
    productType: string
  }
}

export type MobCommerce = {
  productViews: { value: number }
  _telus: { customProductViews: { value: number } }
}

// Hardcoded because this block only exists for mobility phones today; no category/productType
// field exists in the pepSection or pepPrice Contentful content models. If this ever needs to
// vary, consider sourcing from alloyDataLayer's pageProductCategory instead of adding new fields.
const MOB_PEP_CATEGORY = 'mobility'
const MOB_PEP_PRODUCT_TYPE = 'phones'

const normalize = (value?: string): string =>
  typeof value === 'string' ? value.trim().split(' ').join('_').toLowerCase() : ''

export const buildMobProductListItem = ({
  sku,
  name,
  brand,
}: {
  sku?: string
  name?: string
  brand?: string
}): MobProductListItem | undefined => {
  if (!sku) return undefined

  const productBrand = normalize(brand)
  const productName = normalize(name)

  return {
    SKU: sku,
    name: productName,
    _telus: {
      productName: [productBrand, productName].filter(Boolean).join('_'),
      productBrand,
      category: MOB_PEP_CATEGORY,
      productType: MOB_PEP_PRODUCT_TYPE,
    },
  }
}

export const buildMobCommerce = (): MobCommerce => ({
  productViews: { value: 1 },
  _telus: { customProductViews: { value: 1 } },
})
